import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/ico_dropdown_arrow_down.svg?url_encode")